export default "__VITE_ASSET__AjP9KkUn__"